/**
 * @fileoverview GET handler for the "/databricks_deltashares/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { deltashares } from "./constants";
import type { GetDeltasharesResult } from "./types";
import { isGetDeltasharesResult } from "./validators";

export const getDeltashares = reactQueryFetcherAdapter(
  deltashares,
  (signal: AbortSignal, appGroupId: string): Promise<GetDeltasharesResult> => {
    return fetch(`/databricks_deltashares/${appGroupId}`, "GET", {}, { signal });
  },
  isGetDeltasharesResult
);
